import template from "./client-settings.html";
import controller from "./client-settings.controller";
import "./client-settings.scss";

const ClientSettingsComponent = {
    template,
    controller,
    controllerAs: "ClientSettings"
};

export default ClientSettingsComponent;


// WEBPACK FOOTER //
// ./sources/components/clients/client-settings/client-settings.component.js